import { TableHeadersConfig } from '../../utils/utils';

export const cardsTableConfig: TableHeadersConfig[] = [
  {
    title: '#',
  },
  {
    title: 'Card Name',
    sortingKey: 'name',
  },
  {
    title: 'Remaining credit',
    sortingKey: 'balance',
  },
  {
    title: 'Type',
    sortingKey: 'type.name',
  },
  {
    title: 'Circuit',
    sortingKey: 'type.credit',
  },
  {
    title: 'Status',
    sortingKey: 'status',
  },
  {
    title: 'Activation Date',
  },
  {
    title: 'Expiration Date',
  },
  {
    title: 'Notes',
  },
  {
    title: 'Action',
  },
];



// WEBPACK FOOTER //
// ./src/pages/cards/cardsTableConfig.ts